import { Grid, styled } from '@mui/material';

export const CategoryContainer = styled(Grid)`
  padding: 25px;
`;
